"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.media = exports.MEDIA_TABLET = void 0;
const breakpoints_1 = require("./breakpoints");
const MEDIA_MOBILE = `@media screen and (max-width: 895px)`;
exports.MEDIA_TABLET = `@media screen and (min-width: ${breakpoints_1.breakpoints[0]})`;
const MEDIA_DESKTOP = `@media screen and (min-width: ${breakpoints_1.breakpoints[1]})`;
exports.media = {
    mobile: MEDIA_MOBILE,
    tablet: exports.MEDIA_TABLET,
    desktop: MEDIA_DESKTOP,
};
//# sourceMappingURL=media.js.map